import React, { useState, useEffect } from "react";
import cn from "classnames";
import copy from 'copy-to-clipboard';

import { PageBase } from "../PageBase";
import {
    readDay,
    writeDay,
    getDefaultDay,
    getDefaultProteinValue,
    getDefaultGroceryValue,
    getDefaultOmegaFatValue,
    getDefaultTastyValue,
    getDefaultCustomValue,
} from "./utils/workWithData";
import { useDay } from "./utils/useDay";
import { countEnergyInProduct, countEnergyInDay } from "./utils/countEnergy";
import config from "./config";

import BEM from "./FoodConstructor.module.scss";

export const FoodConstructor = () => {
    const [day, setDay] = useDay(getDefaultDay());
    const [clearLocalStorageVisible, setcCearLocalStorageVisible] =
        useState(false);

    useEffect(() => {
        readDay(new Date()).then((day) => {
            setDay(day);
        });
    }, []);

    const totalEnergy = countEnergyInDay(day);

    return (
        <div className={BEM.block}>
            <PageBase heading="Food Constructor">
                <h1 className={BEM.caloriesTotal}>
                    Всього калорій:{" "}
                    <span
                        className={cn({
                            [BEM.caloriesTotalSpan_white]: totalEnergy < 1500,
                            [BEM.caloriesTotalSpan_green]:
                                totalEnergy >= 1500 && totalEnergy < 1800,
                            [BEM.caloriesTotalSpan_yellow]:
                                totalEnergy >= 1800 && totalEnergy < 2000,
                            [BEM.caloriesTotalSpan_red]: totalEnergy > 2000,
                        })}
                    >
                        {totalEnergy}
                    </span>
                </h1>
                <div className={BEM.group}>
                    <h2 className={BEM.heading}>Білок</h2>
                    <ul className={BEM.list}>
                        {day.protein.map((product, index) => (
                            <li key={product.id} className={BEM.product}>
                                <select
                                    className={BEM.select}
                                    value={product.id}
                                    onChange={(event) => {
                                        const targetId = event.target.value;
                                        const targetInConfig =
                                            config.protein.find(
                                                (possibleProduct) =>
                                                    possibleProduct.id ===
                                                    targetId,
                                            );
                                        day.protein[index] = {
                                            ...targetInConfig,
                                        };
                                        day.protein[index].weight =
                                            product.weight;

                                        setDay({ ...day });
                                    }}
                                >
                                    {config.protein.map((confProduct) => (
                                        <option
                                            key={confProduct.id}
                                            value={confProduct.id}
                                            selected={
                                                confProduct.id === product.id
                                            }
                                        >
                                            {confProduct.name}
                                            {": "}
                                            {confProduct.energy}
                                            {"cal"}
                                        </option>
                                    ))}
                                </select>

                                <div
                                    className={cn({
                                        [BEM.productRight]: true,
                                        [BEM[
                                            `productRight_${
                                                String(product.weight).length
                                            }digits`
                                        ]]: true,
                                    })}
                                >
                                    <label className={BEM.productWeight}>
                                        <input
                                            type="number"
                                            value={String(product.weight)}
                                            className={BEM.productWeightInput}
                                            onChange={(event) => {
                                                product.weight =
                                                    +event.target.value;

                                                setDay({ ...day });
                                            }}
                                        />
                                        <span className={BEM.productWeightG}>
                                            г
                                        </span>
                                    </label>
                                    <span className={BEM.productCalories}>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            ккал
                                        </span>
                                        <span
                                            className={BEM.productCaloriesValue}
                                        >
                                            {product.energy}
                                        </span>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            100г
                                        </span>
                                    </span>
                                    <span className={BEM.productCalories}>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            ккал
                                        </span>
                                        <span
                                            className={BEM.productCaloriesValue}
                                        >
                                            {countEnergyInProduct(product)}
                                        </span>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            total
                                        </span>
                                    </span>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <div className={BEM.buttonsGroup}>
                        <button
                            className={BEM.addNewButton}
                            onClick={() => {
                                const product = getDefaultProteinValue();
                                day.protein.push(product);
                                setDay({ ...day });
                            }}
                        >
                            +
                        </button>
                        <button
                            onClick={() => {
                                day.protein = [];
                                setDay({ ...day });
                            }}
                            className={BEM.removeButton}
                        ></button>
                    </div>
                </div>
                <div className={BEM.group}>
                    <h2 className={BEM.heading}>Бакалія</h2>
                    <ul className={BEM.list}>
                        {day.grocery.map((product, index) => (
                            <li key={product.id} className={BEM.product}>
                                <select
                                    className={BEM.select}
                                    value={product.id}
                                    onChange={(event) => {
                                        const targetId = event.target.value;
                                        const targetInConfig =
                                            config.grocery.find(
                                                (possibleProduct) =>
                                                    possibleProduct.id ===
                                                    targetId,
                                            );
                                        day.grocery[index] = {
                                            ...targetInConfig,
                                        };
                                        day.grocery[index].weight =
                                            product.weight;

                                        setDay({ ...day });
                                    }}
                                >
                                    {config.grocery.map((confProduct) => (
                                        <option
                                            key={confProduct.id}
                                            value={confProduct.id}
                                            selected={
                                                confProduct.id === product.id
                                            }
                                        >
                                            {confProduct.name}
                                            {": "}
                                            {confProduct.energy}
                                            {"cal"}
                                        </option>
                                    ))}
                                </select>

                                <div
                                    className={cn({
                                        [BEM.productRight]: true,
                                        [BEM[
                                            `productRight_${
                                                String(product.weight).length
                                            }digits`
                                        ]]: true,
                                    })}
                                >
                                    <label className={BEM.productWeight}>
                                        <input
                                            type="number"
                                            value={String(product.weight)}
                                            className={BEM.productWeightInput}
                                            onChange={(event) => {
                                                product.weight =
                                                    +event.target.value;

                                                setDay({ ...day });
                                            }}
                                        />
                                        <span className={BEM.productWeightG}>
                                            г
                                        </span>
                                    </label>
                                    <span className={BEM.productCalories}>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            ккал
                                        </span>
                                        <span
                                            className={BEM.productCaloriesValue}
                                        >
                                            {product.energy}
                                        </span>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            100г
                                        </span>
                                    </span>
                                    <span className={BEM.productCalories}>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            ккал
                                        </span>
                                        <span
                                            className={BEM.productCaloriesValue}
                                        >
                                            {countEnergyInProduct(product)}
                                        </span>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            total
                                        </span>
                                    </span>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <div className={BEM.buttonsGroup}>
                        <button
                            className={BEM.addNewButton}
                            onClick={() => {
                                const product = getDefaultGroceryValue();
                                day.grocery.push(product);
                                setDay({ ...day });
                            }}
                        >
                            +
                        </button>
                        <button
                            onClick={() => {
                                day.grocery = [];
                                setDay({ ...day });
                            }}
                            className={BEM.removeButton}
                        ></button>
                    </div>
                </div>
                <div className={BEM.group}>
                    <h2 className={BEM.heading}>Омега жири</h2>
                    <ul className={BEM.list}>
                        {day.omegaFats.map((product, index) => (
                            <li key={product.id} className={BEM.product}>
                                <select
                                    className={BEM.select}
                                    value={product.id}
                                    onChange={(event) => {
                                        const targetId = event.target.value;
                                        const targetInConfig =
                                            config.omegaFats.find(
                                                (possibleProduct) =>
                                                    possibleProduct.id ===
                                                    targetId,
                                            );
                                        day.omegaFats[index] = {
                                            ...targetInConfig,
                                        };
                                        day.omegaFats[index].weight =
                                            product.weight;

                                        setDay({ ...day });
                                    }}
                                >
                                    {config.omegaFats.map((confProduct) => (
                                        <option
                                            key={confProduct.id}
                                            value={confProduct.id}
                                            selected={
                                                confProduct.id === product.id
                                            }
                                        >
                                            {confProduct.name}
                                            {": "}
                                            {confProduct.energy}
                                            {"cal"}
                                        </option>
                                    ))}
                                </select>

                                <div
                                    className={cn({
                                        [BEM.productRight]: true,
                                        [BEM[
                                            `productRight_${
                                                String(product.weight).length
                                            }digits`
                                        ]]: true,
                                    })}
                                >
                                    <label className={BEM.productWeight}>
                                        <input
                                            type="number"
                                            value={String(product.weight)}
                                            className={BEM.productWeightInput}
                                            onChange={(event) => {
                                                product.weight =
                                                    +event.target.value;

                                                setDay({ ...day });
                                            }}
                                        />
                                        <span className={BEM.productWeightG}>
                                            г
                                        </span>
                                    </label>
                                    <span className={BEM.productCalories}>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            ккал
                                        </span>
                                        <span
                                            className={BEM.productCaloriesValue}
                                        >
                                            {product.energy}
                                        </span>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            100г
                                        </span>
                                    </span>
                                    <span className={BEM.productCalories}>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            ккал
                                        </span>
                                        <span
                                            className={BEM.productCaloriesValue}
                                        >
                                            {countEnergyInProduct(product)}
                                        </span>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            total
                                        </span>
                                    </span>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <div className={BEM.buttonsGroup}>
                        <button
                            className={BEM.addNewButton}
                            onClick={() => {
                                const product = getDefaultOmegaFatValue();
                                day.omegaFats.push(product);
                                setDay({ ...day });
                            }}
                        >
                            +
                        </button>
                        <button
                            onClick={() => {
                                day.omegaFats = [];
                                setDay({ ...day });
                            }}
                            className={BEM.removeButton}
                        ></button>
                    </div>
                </div>
                <div className={BEM.group}>
                    <h2 className={BEM.heading}>Лакоття</h2>
                    <ul className={BEM.list}>
                        {day.tasty.map((product, index) => (
                            <li key={product.id} className={BEM.product}>
                                <select
                                    className={BEM.select}
                                    value={product.id}
                                    onChange={(event) => {
                                        const targetId = event.target.value;
                                        const targetInConfig =
                                            config.tasty.find(
                                                (possibleProduct) =>
                                                    possibleProduct.id ===
                                                    targetId,
                                            );
                                        day.tasty[index] = {
                                            ...targetInConfig,
                                        };
                                        day.tasty[index].weight =
                                            product.weight;

                                        setDay({ ...day });
                                    }}
                                >
                                    {config.tasty.map((confProduct) => (
                                        <option
                                            key={confProduct.id}
                                            value={confProduct.id}
                                            selected={
                                                confProduct.id === product.id
                                            }
                                        >
                                            {confProduct.name}
                                            {": "}
                                            {confProduct.energy}
                                            {"cal"}
                                        </option>
                                    ))}
                                </select>

                                <div
                                    className={cn({
                                        [BEM.productRight]: true,
                                        [BEM[
                                            `productRight_${
                                                String(product.weight).length
                                            }digits`
                                        ]]: true,
                                    })}
                                >
                                    <label className={BEM.productWeight}>
                                        <input
                                            type="number"
                                            value={String(product.weight)}
                                            className={BEM.productWeightInput}
                                            onChange={(event) => {
                                                product.weight =
                                                    +event.target.value;

                                                setDay({ ...day });
                                            }}
                                        />
                                        <span className={BEM.productWeightG}>
                                            г
                                        </span>
                                    </label>
                                    <span className={BEM.productCalories}>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            ккал
                                        </span>
                                        <span
                                            className={BEM.productCaloriesValue}
                                        >
                                            {product.energy}
                                        </span>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            100г
                                        </span>
                                    </span>
                                    <span className={BEM.productCalories}>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            ккал
                                        </span>
                                        <span
                                            className={BEM.productCaloriesValue}
                                        >
                                            {countEnergyInProduct(product)}
                                        </span>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            total
                                        </span>
                                    </span>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <div className={BEM.buttonsGroup}>
                        <button
                            className={BEM.addNewButton}
                            onClick={() => {
                                const product = getDefaultTastyValue();
                                day.tasty.push(product);
                                setDay({ ...day });
                            }}
                        >
                            +
                        </button>
                        <button
                            onClick={() => {
                                day.tasty = [];
                                setDay({ ...day });
                            }}
                            className={BEM.removeButton}
                        ></button>
                    </div>
                </div>
                <div className={BEM.group}>
                    <h2 className={BEM.heading}>Custom</h2>
                    <ul className={BEM.list}>
                        {day.custom.map((product, index) => (
                            <li key={product.id} className={BEM.product}>
                                <input
                                    className={BEM.select}
                                    value={product.name}
                                    onChange={(event) => {
                                        const newName = event.target.value;
                                        day.custom[index].name = newName;
                                        setDay({ ...day });
                                    }}
                                />

                                <div
                                    className={cn({
                                        [BEM.productRight]: true,
                                        [BEM[
                                            `productRight_${
                                                String(product.weight).length
                                            }digits`
                                        ]]: true,
                                        [BEM.productRight_for_custom]: true,
                                    })}
                                >
                                    <label className={BEM.productWeight}>
                                        <input
                                            type="number"
                                            value={String(product.weight)}
                                            className={BEM.productWeightInput}
                                            onChange={(event) => {
                                                product.weight =
                                                    +event.target.value;

                                                setDay({ ...day });
                                            }}
                                        />
                                        <span className={BEM.productWeightG}>
                                            г
                                        </span>
                                    </label>
                                    <span className={BEM.productCalories}>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            ккал
                                        </span>
                                        <input
                                            className={BEM.productCaloriesInput}
                                            value={String(product.energy)}
                                            type="number"
                                            onChange={(event) => {
                                                product.energy =
                                                    +event.target.value;

                                                setDay({ ...day });
                                            }}
                                        />
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            100г
                                        </span>
                                    </span>
                                    <span className={BEM.productCalories}>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            ккал
                                        </span>
                                        <span
                                            className={BEM.productCaloriesValue}
                                        >
                                            {countEnergyInProduct(product)}
                                        </span>
                                        <span
                                            className={BEM.productCaloriesTitle}
                                        >
                                            total
                                        </span>
                                    </span>
                                </div>
                            </li>
                        ))}
                    </ul>
                    <div className={BEM.buttonsGroup}>
                        <button
                            className={BEM.addNewButton}
                            onClick={() => {
                                const product = getDefaultCustomValue();
                                day.custom.push(product);
                                setDay({ ...day });
                            }}
                        >
                            +
                        </button>
                        <button
                            onClick={() => {
                                day.custom = [];
                                setDay({ ...day });
                            }}
                            className={BEM.removeButton}
                        ></button>
                    </div>
                </div>

                <div style={{ marginTop: "180px", display: "block" }}>
                    <button
                        onClick={() =>
                            setcCearLocalStorageVisible(
                                !clearLocalStorageVisible,
                            )
                        }
                        style={{
                            background: "none",
                            color: "#fff",
                            border: "none",
                        }}
                    >
                        Clear localstorage
                    </button>
                    {clearLocalStorageVisible && (
                        <>
                            <div>are you shure?</div>
                            <button
                                style={{
                                    marginRight: 30,
                                    background: "lightgreen",
                                }}
                                onClick={() =>
                                    setcCearLocalStorageVisible(false)
                                }
                            >
                                <big>NO</big>
                            </button>
                            <button
                                onClick={() => {
                                    localStorage.removeItem("plan/food");
                                    window.location.reload();
                                }}
                            >
                                yes
                            </button>
                        </>
                    )}
                </div>
                <div style={{ display: "block", marginTop: "35px" }}>
                    <button
                        onClick={() =>
                            alert(
                                copy(localStorage.getItem("plan/food"))
                                    ? "success"
                                    : "fail",
                            )
                        }
                        style={{
                            background: "none",
                            color: "#fff",
                            border: "none",
                            cursor: "pointer",
                        }}
                    >
                        Copy localStorage to clipboard
                    </button>
                </div>
            </PageBase>
        </div>
    );
};
